import * as React from 'react'
import { Spinner, SpinnerSize } from "@fluentui/react"

export const SpinnerTable = () => {

    return (<div
        style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100px",
        }}
    >
        <Spinner
            size={SpinnerSize.large}
            label="Obteniendo Información"
            ariaLive="assertive"
        />
    </div>)
}